import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class PublicHolidayForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  order: number = 0
  date: string = ''
  year: number = 0
  isRecurring: boolean = false

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire')),
    date: combineRules(requiredRule('La date est obligatoire'))
  }

  constructor(data?: Partial<PublicHolidayForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.order = data.order ?? 0
      this.date = data.date ?? ''
      this.year = data.year ?? 0
      this.isRecurring = data.isRecurring ?? false
    }
  }
}
